import React from 'react';
import { useVersionCheck } from '../../hooks/useVersionCheck';

export const VersionUpdateBanner: React.FC = () => {
  const { newVersionAvailable, refresh } = useVersionCheck();

  if (!newVersionAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-600 text-white px-4 py-2 flex items-center justify-center gap-3 shadow-md">
      <span className="text-sm font-medium">
        En ny versjon av applikasjonen er tilgjengelig.
      </span>
      <button
        onClick={refresh}
        className="bg-white text-blue-600 text-sm font-semibold px-3 py-1 rounded hover:bg-blue-50 transition-colors"
      >
        Oppdater nå
      </button>
    </div>
  );
};
